module.exports = __webpack_public_path__ + "static/media/flowchart_token-authentication.cf7b52b4.svg";